import { Typography } from "@mui/material";
import { Dialog } from "components/Dialog";

/**
 * Detach spells out the consequences because they reach past this shipment: the
 * containers stop pointing at the manifest's waste lines, and auto-match is
 * suppressed so the pipeline does not immediately undo the decision.
 */
export function DetachManifestDialog({
  trackingNumber,
  detaching,
  onConfirm,
  onClose,
}: {
  trackingNumber: string | null;
  detaching: boolean;
  onConfirm: () => void;
  onClose: () => void;
}) {
  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth="xs"
      title="Detach this manifest?"
      primaryActionButtonProps={{
        saveText: "Detach manifest",
        loading: detaching,
        onClick: onConfirm,
      }}
    >
      <Typography variant="body2">
        {trackingNumber ? `Manifest ${trackingNumber}` : "This manifest"} will be unlinked, and the
        containers on this shipment will no longer point at its waste lines. The manifest itself is
        not deleted, and this shipment&apos;s contents become editable again. Automatic matching
        will not re-link this manifest on its own — link it by hand if you detached it in error.
      </Typography>
    </Dialog>
  );
}
